import { parseStringToBoolean } from "utils/booleanUtils";

/* Object with properties set to true when they should be enabled */
const featureFlags = {
  accountArea: parseStringToBoolean(process.env.REACT_APP_ENABLE_ACCOUNT_AREA),
  google_analytics: parseStringToBoolean(
    process.env.REACT_APP_ENABLE_GOOGLE_ANALYTICS
  ),
  hotjar_analytics: parseStringToBoolean(
    process.env.REACT_APP_ENABLE_HOTJAR_ANALYTICS
  ),
  cookieBanner: parseStringToBoolean(
    process.env.REACT_APP_ENABLE_COOKIE_BANNER
  ),
  displayTestBanner: parseStringToBoolean(
    process.env.REACT_APP_ENABLE_TEST_BANNER
  ),
  displayDevBanner: parseStringToBoolean(
    process.env.REACT_APP_ENABLE_DEV_BANNER
  ),
  displayEnvironmentLabel: parseStringToBoolean(
    process.env.REACT_APP_ENABLE_ENVIRONMENT_LABEL
  ),
  displayBatteryStorageFuelType: parseStringToBoolean(
    process.env.REACT_APP_ENABLE_BATTERY_STORAGE
  ),
  rebrand: parseStringToBoolean(process.env.REACT_APP_ENABLE_REBRAND),
};

export default featureFlags;
